const KEY = 'warung-digital:warung-token'

export function readWarungToken(): string | null {
  return globalThis.localStorage?.getItem(KEY) ?? null
}

export function saveWarungToken(token: string): void {
  globalThis.localStorage?.setItem(KEY, token)
}

export function clearWarungToken(): void {
  globalThis.localStorage?.removeItem(KEY)
}
